var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPadelmvpHorizontal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 754,
    height: 144,
    viewBox: "0 0 754 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_961)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_76_961)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_76_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.498 14.0787C72.7273 14.0787 80.6793 15.2324 87.7227 18.2769C94.7788 21.2479 100.871 25.9828 105.009 32.7798C105.139 32.9942 105.267 33.2093 105.393 33.4254C106.372 35.1135 108.883 35.3003 109.922 33.648L117.075 22.2642L117.383 21.7935C120.627 16.9805 126.059 14.0787 131.888 14.0787H147.113C154.664 14.0789 161.348 18.9208 163.717 26.0621L163.826 26.4039L172.395 54.1148C173.149 56.555 176.682 56.3034 177.083 53.7808L181.047 28.8277L181.115 28.4312C182.626 20.1386 189.857 14.0787 198.324 14.0787H226.909C243.435 14.0787 258.497 17.8984 269.943 27.6568C269.96 27.6707 269.976 27.6849 269.992 27.6988C269.998 27.7041 270.005 27.7091 270.012 27.7144V27.7154C270.893 28.4629 271.738 29.2318 272.548 30.0211C273.826 31.2669 276.085 30.6143 276.362 28.8511L276.429 28.4547C277.93 20.1513 285.166 14.0789 293.643 14.0787H349.325C352.25 14.0787 354.986 14.7903 357.387 16.0396C358.219 16.4726 359.217 16.4738 360.05 16.0416C362.472 14.784 365.214 14.0787 368.102 14.0787H386.383C397.13 14.0787 405.336 23.6777 403.664 34.2935L396.912 77.1636C396.682 78.6279 397.814 79.9517 399.296 79.9517H413.288C424.033 79.9517 432.239 89.548 430.57 100.163L428.312 114.519C426.975 123.027 419.644 129.296 411.031 129.296H355.356C352.429 129.296 349.691 128.583 347.29 127.333C346.458 126.899 345.458 126.898 344.625 127.331C342.202 128.59 339.458 129.296 336.568 129.296H281.011C274.146 129.296 268.319 125.379 265.44 119.782C264.658 118.26 262.653 117.586 261.232 118.54C257.556 121.009 253.576 123.071 249.337 124.745L249.256 124.776L249.176 124.807C241.003 127.926 232.038 129.296 222.565 129.296H185.578C183.51 129.296 181.536 128.94 179.709 128.29C179.094 128.071 178.42 128.071 177.805 128.29C175.98 128.939 174.004 129.296 171.922 129.296H154.986C147.002 129.296 140.03 123.89 138.043 116.157L137.545 114.218C137.271 113.152 136.309 112.406 135.208 112.406H121.014C120.155 112.406 119.361 112.862 118.929 113.603L114.844 120.612C111.71 125.989 105.954 129.296 99.7305 129.296H81.4736C67.7144 129.296 59.3406 114.145 66.6611 102.495C67.3206 101.444 66.4758 100.084 65.2383 100.166C63.4431 100.284 61.6265 100.341 59.793 100.341H57.3613C56.1747 100.342 55.1642 101.205 54.9785 102.377L53.0527 114.539C51.7069 123.038 44.3797 129.296 35.7744 129.296H17.4971C6.741 129.296 -1.46677 119.681 0.220703 109.058L12.9658 28.8277C14.3154 20.3323 21.6412 14.0787 30.2432 14.0787H64.498Z",
    fill: "#304D95"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_76_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.799 29.6326H386.687C386.784 29.6326 386.858 29.7187 386.843 29.8142L376.697 94.2292C376.591 94.8994 377.109 95.5054 377.788 95.5056H413.591C413.688 95.5056 413.763 95.5925 413.748 95.6882L410.929 113.608C410.917 113.685 410.852 113.742 410.774 113.742H351.488C351.391 113.742 351.316 113.655 351.332 113.559L364.644 29.7654C364.656 29.6889 364.722 29.6328 364.799 29.6326Z",
    fill: "url(#paint0_linear_76_961)",
    stroke: "white",
    strokeWidth: 0.946653
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.339 29.6326H349.626C349.723 29.6326 349.798 29.7186 349.783 29.8142L347.206 46.2869C347.194 46.3637 347.127 46.4207 347.049 46.4207H309.642C309.099 46.4209 308.636 46.8164 308.551 47.3533L306.337 61.4128C306.232 62.083 306.75 62.6891 307.428 62.6892H341.664C341.76 62.6894 341.834 62.7762 341.819 62.8718L339.243 79.2244C339.23 79.3009 339.165 79.3571 339.087 79.3572H304.333C303.791 79.3572 303.328 79.7518 303.243 80.2878L300.79 95.6746C300.683 96.3454 301.201 96.9529 301.88 96.9529H338.889C338.986 96.9529 339.06 97.0398 339.045 97.1355L336.467 113.608C336.455 113.685 336.39 113.742 336.312 113.742H277.146C277.049 113.742 276.975 113.655 276.99 113.559L290.183 29.7654C290.195 29.6887 290.262 29.6326 290.339 29.6326Z",
    fill: "url(#paint1_linear_76_961)",
    stroke: "white",
    strokeWidth: 0.946653
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.021 29.6326H225.128C239.457 29.6326 250.431 32.9545 258.118 39.532L258.12 39.5339C265.561 45.8241 269.45 54.4573 269.758 65.488L269.776 66.5632C269.776 73.3476 268.698 79.6445 266.548 85.4578L266.547 85.4607C264.479 91.1878 261.339 96.1553 257.126 100.368L257.123 100.371C252.993 104.581 247.905 107.883 241.85 110.274C235.801 112.582 228.782 113.742 220.784 113.742H181.71C181.613 113.742 181.539 113.655 181.554 113.559L194.866 29.7654C194.878 29.6889 194.944 29.6328 195.021 29.6326ZM215.17 47.3855C214.627 47.3855 214.165 47.7802 214.079 48.3162L206.68 94.7097C206.573 95.3806 207.091 95.988 207.771 95.988H221.025C225.176 95.988 228.859 95.3369 232.063 94.0222L232.069 94.0203C235.35 92.626 238.066 90.6521 240.209 88.0974C242.346 85.5499 243.942 82.5147 245.004 79.0017C246.146 75.4102 246.714 71.3821 246.714 66.9216C246.714 60.8332 245.026 56.0915 241.589 52.7722L241.251 52.4558C237.592 49.0489 232.189 47.3856 225.128 47.3855H215.17Z",
    fill: "url(#paint2_linear_76_961)",
    stroke: "white",
    strokeWidth: 0.946653
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.487 29.6326H149.197C149.543 29.6327 149.848 29.8579 149.95 30.1882L175.47 112.719C175.627 113.227 175.248 113.742 174.717 113.742H154.839C154.767 113.742 154.704 113.693 154.686 113.623L150.589 97.6804C150.464 97.1924 150.024 96.8514 149.52 96.8513H112.558C112.165 96.8514 111.802 97.0598 111.604 97.3992L102.125 113.664C102.096 113.712 102.045 113.742 101.989 113.742H80.6265C80.006 113.742 79.6284 113.058 79.9585 112.533L131.819 30.0017C131.963 29.772 132.215 29.6326 132.487 29.6326ZM138.286 52.6941C138.083 52.6942 137.894 52.7886 137.771 52.946L137.723 53.0173L122.833 78.3992C122.402 79.1354 122.932 80.0622 123.786 80.0623H144.57C145.294 80.062 145.822 79.3768 145.637 78.6765L138.917 53.1804L138.88 53.0779C138.776 52.8475 138.545 52.6941 138.286 52.6941Z",
    fill: "url(#paint3_linear_76_961)",
    stroke: "white",
    strokeWidth: 0.946653
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4951 29.6326H65.7324C72.6885 29.6326 78.4093 30.6321 82.915 32.6082L82.9219 32.6111C87.4289 34.5088 90.7631 37.2644 92.9561 40.867C95.155 44.4797 96.2656 48.8143 96.2656 53.8914C96.2656 60.5023 94.9116 66.1276 92.2266 70.7869L92.2256 70.7899C89.6261 75.3585 85.6855 78.8327 80.3789 81.2088L80.376 81.2098C75.1456 83.5872 68.7019 84.7869 61.0273 84.7869H44.7324C43.8787 84.7869 43.1511 85.4076 43.0176 86.2508L38.7705 113.076C38.7098 113.459 38.3793 113.742 37.9912 113.742H17.3838C16.8988 113.742 16.5284 113.308 16.6045 112.829L29.7158 30.2977C29.7767 29.9146 30.1073 29.6327 30.4951 29.6326ZM50.7646 46.4207C49.9108 46.4209 49.184 47.0422 49.0508 47.8856L46.1914 65.992C46.0252 67.0453 46.8399 67.9979 47.9062 67.9979H61.8721C66.1975 67.9978 69.5468 67.0196 71.8379 64.9832L71.8447 64.9764C74.1383 62.8527 75.2539 59.8155 75.2539 55.9422C75.2538 52.6984 74.2078 50.2415 72.041 48.6815C69.9874 47.1454 66.8081 46.4207 62.5957 46.4207H50.7646Z",
    fill: "url(#paint4_linear_76_961)",
    stroke: "white",
    strokeWidth: 0.946653
  }))), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M681.878 5.38965C718.494 5.38965 748.176 35.0722 748.176 71.6875C748.176 108.303 718.494 137.985 681.878 137.985H510.474C473.859 137.985 444.176 108.303 444.176 71.6875C444.176 35.0722 473.859 5.38965 510.474 5.38965H681.878Z",
    fill: "url(#paint5_linear_76_961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.878 0C721.471 1.64953e-05 753.566 32.0954 753.566 71.6875C753.566 111.28 721.471 143.375 681.878 143.375H510.474C470.882 143.375 438.787 111.28 438.787 71.6875C438.787 32.0954 470.882 8.24658e-06 510.474 0H681.878ZM510.474 5.38965C473.859 5.38966 444.176 35.0722 444.176 71.6875C444.176 108.303 473.859 137.985 510.474 137.985H681.878C718.494 137.985 748.176 108.303 748.176 71.6875C748.176 35.0722 718.494 5.38966 681.878 5.38965H510.474Z",
    fill: "url(#paint6_linear_76_961)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.566,
    y: 10.7796,
    width: 293.22,
    height: 121.816,
    rx: 60.9078,
    fill: "url(#paint7_linear_76_961)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_dd_76_961)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M647.907 106.455C646.716 106.455 645.751 105.49 645.751 104.299V40.5861C645.751 39.3954 646.716 38.4301 647.907 38.4301H678.461C683.607 38.4301 687.981 39.3307 691.583 41.1318C695.186 42.8686 697.92 45.4095 699.785 48.7545C701.715 52.0351 702.68 56.0233 702.68 60.7192C702.68 65.2863 701.715 69.2746 699.785 72.6838C697.92 76.0288 695.186 78.6019 691.583 80.403C687.981 82.1398 683.607 83.0082 678.461 83.0082H665.661C664.47 83.0082 663.505 83.9735 663.505 85.1642V104.299C663.505 105.49 662.54 106.455 661.349 106.455H647.907ZM663.505 67.2472C663.505 68.4379 664.47 69.4032 665.661 69.4032H675.373C678.718 69.4032 681.291 68.6956 683.092 67.2804C684.894 65.8009 685.794 63.6138 685.794 60.7192C685.794 57.7602 684.894 55.5731 683.092 54.1579C681.291 52.7427 678.718 52.0351 675.373 52.0351H665.661C664.47 52.0351 663.505 53.0004 663.505 54.1911V67.2472Z",
    fill: "url(#paint8_linear_76_961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.907 106.455C646.716 106.455 645.751 105.49 645.751 104.299V40.5861C645.751 39.3954 646.716 38.4301 647.907 38.4301H678.461C683.607 38.4301 687.981 39.3307 691.583 41.1318C695.186 42.8686 697.92 45.4095 699.785 48.7545C701.715 52.0351 702.68 56.0233 702.68 60.7192C702.68 65.2863 701.715 69.2746 699.785 72.6838C697.92 76.0288 695.186 78.6019 691.583 80.403C687.981 82.1398 683.607 83.0082 678.461 83.0082H665.661C664.47 83.0082 663.505 83.9735 663.505 85.1642V104.299C663.505 105.49 662.54 106.455 661.349 106.455H647.907ZM663.505 67.2472C663.505 68.4379 664.47 69.4032 665.661 69.4032H675.373C678.718 69.4032 681.291 68.6956 683.092 67.2804C684.894 65.8009 685.794 63.6138 685.794 60.7192C685.794 57.7602 684.894 55.5731 683.092 54.1579C681.291 52.7427 678.718 52.0351 675.373 52.0351H665.661C664.47 52.0351 663.505 53.0004 663.505 54.1911V67.2472Z",
    fill: "url(#paint9_radial_76_961)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.841 106.455C597.996 106.455 597.229 105.962 596.879 105.193L567.869 41.4796C567.219 40.0519 568.263 38.4301 569.832 38.4301H583.974C584.835 38.4301 585.614 38.9424 585.954 39.7333L606.517 87.4741C607.022 88.6477 606.162 89.9554 604.884 89.9554C603.606 89.9554 602.745 88.6477 603.251 87.4741L623.813 39.7333C624.154 38.9424 624.932 38.4301 625.793 38.4301H639.256C640.826 38.4301 641.869 40.054 641.217 41.4819L612.117 105.195C611.766 105.963 611 106.455 610.156 106.455H598.841Z",
    fill: "url(#paint10_linear_76_961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.841 106.455C597.996 106.455 597.229 105.962 596.879 105.193L567.869 41.4796C567.219 40.0519 568.263 38.4301 569.832 38.4301H583.974C584.835 38.4301 585.614 38.9424 585.954 39.7333L606.517 87.4741C607.022 88.6477 606.162 89.9554 604.884 89.9554C603.606 89.9554 602.745 88.6477 603.251 87.4741L623.813 39.7333C624.154 38.9424 624.932 38.4301 625.793 38.4301H639.256C640.826 38.4301 641.869 40.054 641.217 41.4819L612.117 105.195C611.766 105.963 611 106.455 610.156 106.455H598.841Z",
    fill: "url(#paint11_radial_76_961)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.688 106.455C491.497 106.455 490.532 105.49 490.532 104.299V40.5861C490.532 39.3954 491.497 38.4301 492.688 38.4301H504.029C504.811 38.4301 505.531 38.8527 505.912 39.5347L527.917 78.9274C528.287 79.5885 527.809 80.403 527.051 80.403C526.295 80.403 525.817 79.59 526.184 78.9289L548.099 39.538C548.479 38.8541 549.2 38.4301 549.983 38.4301H560.936C562.126 38.4301 563.092 39.3954 563.092 40.5861V104.299C563.092 105.49 562.126 106.455 560.936 106.455H549.231C548.04 106.455 547.075 105.49 547.075 104.299V66.7676C547.075 66.3581 547.407 66.0261 547.816 66.0261C548.387 66.0261 548.744 66.6442 548.458 67.1385L532.162 95.3428C531.777 96.0096 531.065 96.4202 530.295 96.4202H523.137C522.366 96.4202 521.654 96.0084 521.269 95.3403L505.032 67.1482C504.719 66.6063 505.111 65.9296 505.736 65.9296C506.185 65.9296 506.549 66.2936 506.549 66.7425V104.299C506.549 105.49 505.584 106.455 504.393 106.455H492.688Z",
    fill: "url(#paint12_linear_76_961)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.688 106.455C491.497 106.455 490.532 105.49 490.532 104.299V40.5861C490.532 39.3954 491.497 38.4301 492.688 38.4301H504.029C504.811 38.4301 505.531 38.8527 505.912 39.5347L527.917 78.9274C528.287 79.5885 527.809 80.403 527.051 80.403C526.295 80.403 525.817 79.59 526.184 78.9289L548.099 39.538C548.479 38.8541 549.2 38.4301 549.983 38.4301H560.936C562.126 38.4301 563.092 39.3954 563.092 40.5861V104.299C563.092 105.49 562.126 106.455 560.936 106.455H549.231C548.04 106.455 547.075 105.49 547.075 104.299V66.7676C547.075 66.3581 547.407 66.0261 547.816 66.0261C548.387 66.0261 548.744 66.6442 548.458 67.1385L532.162 95.3428C531.777 96.0096 531.065 96.4202 530.295 96.4202H523.137C522.366 96.4202 521.654 96.0084 521.269 95.3403L505.032 67.1482C504.719 66.6063 505.111 65.9296 505.736 65.9296C506.185 65.9296 506.549 66.2936 506.549 66.7425V104.299C506.549 105.49 505.584 106.455 504.393 106.455H492.688Z",
    fill: "url(#paint13_radial_76_961)",
    fillOpacity: 0.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_76_961",
    x: -13,
    y: 5.07867,
    width: 456.787,
    height: 141.218,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_76_961",
    x: 0,
    y: 13.4476,
    width: 430.787,
    height: 116.48,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.946653
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.315551
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.37 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_76_961"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.631102
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.788877
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.126966 0 0 0 0 0.2478 0 0 0 0 0.547799 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_76_961",
    result: "effect2_innerShadow_76_961"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_76_961",
    x: 14.2278,
    y: 29.1589,
    width: 401.257,
    height: 88.5273,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.315551,
    dy: 1.89331
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.788877
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.108852 0 0 0 0 0.23178 0 0 0 0 0.536983 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_76_961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_dd_76_961",
    x: 490.532,
    y: 37.3521,
    width: 212.148,
    height: 71.2591,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.15603
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_76_961"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.07801
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.74902 0 0 0 0 0.290196 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_76_961",
    result: "effect2_dropShadow_76_961"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_76_961",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_961",
    x1: 382.539,
    y1: 29.1589,
    x2: 382.539,
    y2: 114.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_961",
    x1: 313.386,
    y1: 29.1589,
    x2: 313.386,
    y2: 114.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_961",
    x1: 225.61,
    y1: 29.1589,
    x2: 225.61,
    y2: 114.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76_961",
    x1: 127.385,
    y1: 29.1589,
    x2: 127.385,
    y2: 114.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_76_961",
    x1: 56.322,
    y1: 29.159,
    x2: 56.322,
    y2: 114.215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F3F3F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E7E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_76_961",
    x1: 596.176,
    y1: 5.38965,
    x2: 596.176,
    y2: 137.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0B95D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA7D12"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_76_961",
    x1: 596.176,
    y1: 5.38965,
    x2: 596.176,
    y2: 137.985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3B259"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_76_961",
    x1: 594.9,
    y1: 10.7796,
    x2: 594.9,
    y2: 132.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5DE7D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F4D683"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F4CA53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAA938"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_76_961",
    x1: 674.215,
    y1: 38.4301,
    x2: 674.215,
    y2: 106.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_76_961",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(22.2745 -65.7589 5.65821 26.6162 662.963 105.106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_76_961",
    x1: 604.546,
    y1: 38.4301,
    x2: 604.546,
    y2: 106.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_76_961",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(29.7875 -65.7589 7.56665 26.6162 589.499 105.106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_76_961",
    x1: 526.812,
    y1: 38.4301,
    x2: 526.812,
    y2: 106.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#855C0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#322201"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_76_961",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(28.3906 -65.7589 7.21181 26.6162 512.47 105.106)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDB13F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEA93D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_961"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 753.566,
    height: 143.375,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadelmvpHorizontal);
export default __webpack_public_path__ + "static/media/padelmvp_horizontal.af22ec87f050491ba296305b61163a4c.svg";
export { ForwardRef as ReactComponent };